import { Link } from 'react-router'
import { Plus } from 'lucide-react'
import type { ReactNode } from 'react'

interface PageHeaderProps {
  title: string
  subtitle?: string
  actionLabel?: string
  actionTo?: string
  /** ReactNode (icona lucide-react) per le pagine già migrate; stringa 'bi-*' accettata per compatibilità nelle pagine non ancora migrate a Tailwind. */
  actionIcon?: ReactNode | string
  /** Slot per azioni secondarie (es. export) accanto all'azione primaria. */
  extraActions?: ReactNode
}

export function PageHeader({ title, subtitle, actionLabel, actionTo, actionIcon, extraActions }: PageHeaderProps) {
  return (
    <div className="mb-5 flex flex-wrap items-center justify-between gap-3">
      <div>
        <h2 className="m-0 text-2xl font-semibold tracking-tight text-heading sm:text-[26px]">{title}</h2>
        {subtitle && <p className="m-0 mt-1 text-sm text-muted">{subtitle}</p>}
      </div>
      <div className="flex items-center gap-2">
        {extraActions}
        {actionLabel && actionTo && (
          <Link
            to={actionTo}
            className="inline-flex items-center gap-2 rounded-md bg-primary-500 px-4 py-2 text-sm font-semibold text-on-dark transition-colors hover:bg-primary-600"
          >
            {actionIcon == null ? <Plus size={16} /> : typeof actionIcon === 'string' ? <i className={`bi ${actionIcon}`}></i> : actionIcon}
            {actionLabel}
          </Link>
        )}
      </div>
    </div>
  )
}
